import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import InjectStore from '../../common/utils/InjectStore';
import SelectCustom from '../../common/components/input/SelectCustom';

class SelectEmailFrequency extends Component {
  handleNext = () => {
    if (this.props.store.currentData.id) {
      this.props.store.handleSave(true, "Email Frequency Saved Successfully!");
      return;
    }
    this.props.store.showEmailCriteriaDialog();
  }

  handleCancel = () => {
    let me = this,
      { store } = me.props;
      if (!this.props.store.currentData.id) {
        store.handleClose();
        return;
      }
      
      this.props.store.showParsersListDialog();
  }

  handleChange = (value, key) => {
    const { store } = this.props;

    if (key == "frequency") {
      let units, count;

      switch (value['value']) {
        case "every_5_min":
          units = 1;
          count = 5;
          break;
        case "every_10_min":
          units = 1;
          count = 10;
          break;
        case "hourly":
          units = 2;
          count = 1;
          break;
        case "daily":
        default:
          units = 3;
          count = 1;
          break;

      }
      store.handleChange(units, "units");
      store.handleChange(count, "count");
      return;
    }
    store.handleChange(value, key);
  }


  render () {
    const props = this.props,
      { store } = props;


    return (
      <Dialog
        open={store.currentState == "email-frequency"}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth={true}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {/* Select Email Frequency */}
        </DialogTitle>
        <DialogContent >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SelectCustom style={{ minWidth: 120 }}
                value={store.getCurrentEmailFrequencyValue()}
                label="Check for new email"
                values={store.emailFrequencyDropDownList}
                onChange={(value) => this.handleChange(value, "frequency")}
                shouldForwardEvent={false}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
            </Button>
          <Button onClick={this.handleNext} color="primary">
            {store.currentData.id ? "Save" : "Next"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default InjectStore(SelectEmailFrequency);